import BaseDatePicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'

const DatePicker = {
  extends: BaseDatePicker,

  props: {
    format: {
      default: 'd MMMM, yyyy'
    },

    bootstrapStyling: {
      default: false
    },

    fullMonthName: {
      default: false
    },

    calendarButton: {
      default: false
    },

    mondayFirst: {
      default: false
    },

    language: {
      default: function () {
        return es
      }
    }
  }
}

export default DatePicker
